import React from 'react';

import Article from 'grommet/components/Article';
import Form from 'grommet/components/Form';
import FormField from 'grommet/components/FormField';
import Heading from 'grommet/components/Heading';
import Footer from 'grommet/components/Footer';
import Button from 'grommet/components/Button';
import Notification from 'grommet/components/Notification';
import Anchor from 'grommet/components/Anchor';

import request from 'services/request';
import { isEmail } from 'utils/validation';

import TextInput from 'elements/TextInput';

export default class ForgotPassword extends React.Component {

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      errors: {},
      email: '',
    }
  }

  onSubmit(e) {
    e.preventDefault();
    if (!isEmail(this.state.email)) {
      return this.setState({ errors: { email: 'Enter a valid email address.' } })
    }

    request({
      method: 'POST',
      url: '/api/forgot-password',
      body: {
        email: this.state.email,
      }
    })
      .then((res) => {
        this.setState({
          notification: {
            message:'A link to reset your password has been emailed to you',
            status: 'ok',
          },
        })
      })
      .catch(res => {
        this.setState({
          notification: {
            message:'Oops. We couldn\'t find an account with that address',
            status: 'critical',
          },
        });
      });
  }

  render() {
    return (
      <Article align="center" full justify="center">
        <Form onSubmit={this.onSubmit}>
          <Heading tag="h1" strong>Forgot your password?</Heading>
          <p>Enter your email address and we'll send you a link to reset it</p>
          <Notification
            display-if={this.state.notification}
            status={this.state.notification.status}
            message={this.state.notification.message} />
          <FormField
            label="Email address"
            error={this.state.errors.email}>
            <TextInput
              type="email"
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value, errors: {} })}
             />
          </FormField>
          <Footer pad={{vertical: 'medium', between: 'medium'}} direction="column" align="start">
            <Button onClick={this.onSubmit} type="submit" label="OK" primary />
            <Anchor path="/login" label="Go back"></Anchor>
          </Footer>
        </Form>
      </Article>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js